import React, { useState, useEffect } from 'react';
import styles from './InfoBanner.module.css';

const InfoBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isAnimated, setIsAnimated] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  // Fonction pour vérifier si l'utilisateur est admin
  const isAdmin = () => {
    return userInfo && userInfo.roles && userInfo.roles.includes('ROLE_ADMIN');
  };
  
  // Vous pouvez facilement modifier ce texte ici
  const bannerText = "Nouveau site connecté Beebs, il est en version bêta. Vous pouvez prendre l'abonnement sur ce site, il vous sera remboursé. Merci de faire vos retours à <a href='mailto:contact@flowdino.com' style='text-decoration: underline; color: white;'>contact@flowdino.com</a><br />Nouveau système de taille Vinted <a href='https://www.flowdino.com/docs/sales-config#vinted-size-version' style='text-decoration: underline; color: white;'>documentation</a>";
  // const bannerText = "Vinted met en place un nouveau système de tailles, pensez à vérifier votre configuration <a href='/docs/sales-config#vinted-size-version' style='text-decoration: underline; color: white;'>En savoir plus</a>";
  //
  // const bannerText = "⚠️ Les problèmes de publication sur Vinted et Leboncoin sont résolus avec la nouvelle version de l'extenstion (1.2.41)";
  // const bannerText = "Un problème sur l'hébergement Hostinger bloque les accès au service, la résolution est en cours";
  // Nouvelle fonctionnalité : Planifiez vos tâches pour qu'elles s'exécutent toutes seules <a href='https://www.flowdino.com/docs/automation' style='text-decoration: underline; color: white;'>En savoir plus</a>

  // Alternative : Extension en cours de déploiement
  // const bannerText = "Extension en cours de déploiement";
  
  useEffect(() => {
    // Récupérer les informations utilisateur depuis localStorage
    const storedUserInfo = localStorage.getItem('userInfo');
    if (storedUserInfo) {
      setUserInfo(JSON.parse(storedUserInfo));
    }
  }, []);

  useEffect(() => {
    // Animation d'entrée avec délai
    const timer = setTimeout(() => {
      setIsAnimated(true);
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);
  
  // Ne pas afficher le bandeau si l'utilisateur est admin ou si le bandeau est fermé
  if (!isVisible || isAdmin()) {
    return null;
  }

  return (
    <div className={`${styles.infoBanner} ${isAnimated ? styles.animated : ''}`}>
      <div className={styles.container}>
        <div className={styles.content}>
          <span className={styles.icon}>⚠️</span>
          <span 
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: bannerText }}
          />
        </div>
        <button 
          className={styles.closeButton}
          onClick={() => setIsVisible(false)}
          aria-label="Fermer le bandeau"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default InfoBanner;
